import { USCurrency } from 'components/ReusableComponents/FormattedPrice/index'

import styles from './Invoice.module.scss'
import InvoiceTaxRow from './InvoiceTaxRow'

const InvoiceTotal = ({ invoiceDetails, taxRate = 0 }) => {
  const {
    totalAmountDueRemaining,
    totalCommission,
    totalTax,
    totalFixedServices,
    totalMessageFees,
    locale,
    currencyCode,
    subsidiarySubscriptions,
    totalBilledAmount
  } = invoiceDetails

  return (
    <div className={styles.totalContainer}>
      {/* <InvoiceTaxRow
        tax={previousBalance}
        locale={locale}
        currencyCode={currencyCode}
        usd
      >
        Previous balance
      </InvoiceTaxRow> */}
      {totalCommission > 0 && (
        <InvoiceTaxRow
          tax={totalCommission}
          locale={locale}
          currencyCode={currencyCode}
          usd
        >
          AutoInvite commission (USD)
        </InvoiceTaxRow>
      )}
      {subsidiarySubscriptions.find(sub => sub.plan === 'AutoInvite') && (
        <InvoiceTaxRow
          tax={totalFixedServices}
          locale={locale}
          currencyCode={currencyCode}
          usd
        >
          Services with fixed fee
        </InvoiceTaxRow>
      )}
      {totalMessageFees > 0 && (
        <InvoiceTaxRow
          tax={totalMessageFees}
          locale={locale}
          currencyCode={currencyCode}
          usd
        >
          Message fees
        </InvoiceTaxRow>
      )}
      <InvoiceTaxRow tax={totalTax} locale={locale} currencyCode={currencyCode} usd>
        {taxRate.toString()}% sales tax
      </InvoiceTaxRow>
      <div className={styles.total}>
        <div>
          <p styles={styles.totalLabel}>Total billed</p>
          <p styles={styles.totalAmount}>
            <USCurrency withCode>{totalBilledAmount}</USCurrency>
          </p>
        </div>
      </div>
    </div>
  )
}

export default InvoiceTotal
